import { useQuery } from '@ts-gql/apollo';
import { gql } from '@ts-gql/tag';
import React from 'react';

export const GET_NOTIFICATION_COUNT_FOR_USERS_QUERY = gql`
  query GetNotificationCountForUser {
    getNotificationCountForUser {
      unreadNotifications
      jobRecurrences
      jobSignOffRequests
    }
  }
` as import('../../__generated__/ts-gql/GetNotificationCountForUser').type;

export const useGetNotificationCountForUser = () => {
  const res = useQuery(GET_NOTIFICATION_COUNT_FOR_USERS_QUERY, {
    context: { service: 'users' },
  });

  return React.useMemo(
    () => ({ ...res, data: res.data?.getNotificationCountForUser }),
    [res]
  );
};
